import styled, { css } from "styled-components";

interface StyledEditBtnProps {
  $type: "add" | "subtract" | "delete";
  $size: "large" | "medium" | "small";
  $disabled: boolean;
}

export const StyledEditBtn = styled.button<StyledEditBtnProps>`
  display: flex;
  transition: all 0.1s ease;
  width: fit-content;
  height: fit-content;
  box-sizing: border-box;
  background-color: transparent;
  padding: ${({ $size }) => ($size === "small" ? "0.2rem" : "0.3rem")};
  border-radius: 50%;
  cursor: pointer;

  ${({ $type }) =>
    ($type === "add" || $type === "subtract") &&
    css`
      border: 0.1rem solid var(--strong);
      & > .icon path {
        stroke: var(--strong);
      }
    `}

  ${({ $type }) =>
    $type === "delete" &&
    css`
      border: 0.1rem solid transparent;
      background-color: var(--text-gray-4);
      & > .icon path {
        stroke: var(--normal);
      }
    `}

  ${({ $size }) =>
    $size === "large" &&
    css`
      & > .icon {
        width: 1.6rem;
        height: 1.6rem;
        path {
          stroke-width: 1.6;
        }
      }
    `}
    
  ${({ $size }) =>
    $size === "medium" &&
    css`
      & > .icon {
        width: 0.8rem;
        height: 0.8rem;
        path {
          stroke-width: 2.4;
        }
      }
    `}

  ${({ $size }) =>
    $size === "small" &&
    css`
      & > .icon {
        width: 0.6rem;
        height: 0.6rem;
        path {
          stroke-width: 3;
        }
      }
    `}
  &:hover {
    background-color: var(--hovered);
  }
  &:active {
    background-color: var(--pressed-strong);
  }
  ${({ $disabled, $type }) =>
    $disabled &&
    css`
      pointer-events: none;
      cursor: default;
      ${($type === "add" || $type === "subtract") &&
      css`
        border: 0.1rem solid var(--bg-gray-2);
        & > .icon path {
          stroke: var(--bg-gray-2);
        }
      `}

      ${$type === "delete" &&
      css`
        border: 0.1rem solid transparent;
        background-color: var(--bg-gray-2);
        & > .icon path {
          stroke: var(--normal);
        }
      `}
    `}
`;
